import {Nav} from "rsuite";

const styles = {
    marginBottom: '1rem',
};

const UserEditNav = ({ active, onSelect, ...props }) => {
    return (
        <Nav {...props} activeKey={active} onSelect={onSelect} style={styles}>
            <Nav.Item eventKey="skills">Skills</Nav.Item>
            <Nav.Item eventKey="experience">Experience</Nav.Item>
            <Nav.Item eventKey="projects">Projects</Nav.Item>
            <Nav.Item eventKey="education">Education</Nav.Item>
            <Nav.Item eventKey="certifications">Certifications</Nav.Item>
        </Nav>
    );
};

export default UserEditNav;